/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/payment/yandexmoney'>.
 *
 * ЭТАП 2 (28.08.2026, решение Sergei): раздел оплаты расформирован —
 * страница отдаёт постоянный редирект на /delivery, где теперь живёт вся
 * информация о доставке и оплате.
 *
 * Редирект в beforeLoad, а не в loader: грузить тут нечего, а beforeLoad
 * отрабатывает раньше и не тянет за собой рендер. На сервере это честный
 * HTTP 301 с Location, на клиентской навигации — обычный переход.
 * Именно 301, а не 302: адрес выведен из обращения навсегда, поисковик
 * должен склеить его с /delivery.
 *
 * Компоненты страниц (@routes/StaticPages/...) намеренно НЕ удалены —
 * это отдельное решение, здесь только маршрут.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/payment/yandexmoney')({
  beforeLoad: () => {
    throw redirect({ to: '/delivery', statusCode: 301 });
  }
});
